import PageContainer from '../components/page-container/PageContainer';
import PageTitle from '../components/PageTitle';
import NewFYIUsersForm from '../features/new-user/new-fyi-users/NewFYIUsersForm';
import NewUserForm from '../features/new-user/NewUserForm';
import useQueryParam from '../hooks/use-query-param';
import { useIsFirmRole } from '../hooks/use-is-firm-role';
import { Navigate } from 'react-router-dom';
import { useIsActiveSubscription } from '../hooks/use-is-active-subscription';
import { useFirmContext } from '../providers/FirmProvider';

const providers = ['fyi'];

function NewUserPage(): JSX.Element {
    const activeSubscription = useIsActiveSubscription();
    const { isAdmin, isManager } = useIsFirmRole();

    const provider = useQueryParam('provider', providers, 'manual');

    const { shortId } = useFirmContext();
    const { isExternalUser } = useIsFirmRole();

    const title = provider === 'fyi' ? 'Invite Users From FYI' : 'Invite User';

    if ((!isAdmin && !isManager) || !activeSubscription) {
        return <Navigate to="/" />;
    }
    if (isExternalUser) {
        return <Navigate to={`/${shortId}/dashboard`} />;
    }

    return (
        <PageContainer>
            <div className="pb-4">
                <div className="pb-4 border-b">
                    <PageTitle title={title} />
                </div>
                <div className="mx-auto w-full max-w-[600px] mt-8">
                    {provider === 'manual' && <NewUserForm />}
                    {provider === 'fyi' && <NewFYIUsersForm />}
                </div>
            </div>
        </PageContainer>
    );
}
export default NewUserPage;
